import script from "./TaskList.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskList.vue?vue&type=script&setup=true&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=1f4a5232&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4a5232"]])

export default __exports__